import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export const ArcRaidersLogo = t0 => {
  const $ = _c(5);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  const t2 = `w-[${size}px] h-[${size}px] rounded flex items-center justify-center`;
  let t3;
  if ($[0] !== size) {
    t3 = <Image src="/arc_logo_300.png" width={size} height={size} alt="Discord" />;
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};